import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@material-ui/core';

import { SCheckbox, SText } from '@setvi/shared/components';

export interface OptionProps {
  icon?: JSX.Element;
  value: number;
  label: string;
  active: boolean;
  color: string;
  total?: number;
}

interface OptionsProps {
  options: OptionProps[];
  values: number[];
  handleValues: (status: number) => void;
}

const Options = ({ options, values, handleValues }: OptionsProps) => (
  <List
    style={{
      width: '100%',
      padding: 0
    }}>
    {options.map(({ label, value, icon, total }) => (
      <ListItem
        button
        disabled={total !== undefined && !total}
        style={{
          padding: '6px 12px 6px 4px',
          borderRadius: 36
        }}
        key={label}
        onClick={() => handleValues(value)}>
        <ListItemText
          primary={
            <Box display="flex" alignItems="center" gridGap={6}>
              {icon && (
                <Box
                  padding={1}
                  display="flex"
                  alignItems="center"
                  justifyContent="center">
                  {icon}
                </Box>
              )}

              <SText fontColor="#333D47">{label}</SText>
            </Box>
          }
        />
        <ListItemIcon
          style={{
            gap: 4,
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'end'
          }}>
          {total && (
            <Box
              style={{
                color: '#5D7083',
                border: '1px solid #AFBAC6',
                borderRadius: 120,
                height: 20,
                padding: '2px 8px',
                width: 'fit-content',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 600
              }}>
              {total || 0}
            </Box>
          )}

          <SCheckbox checked={values?.includes(value)} />
        </ListItemIcon>
      </ListItem>
    ))}
  </List>
);

export default Options;
